import { API_URL } from '../../configs/apiConfig'
import Swal from 'sweetalert2'

export interface DocumentoVisor {
  id_configuracion: number
  id_area: number
  area: string
  id_proceso: number
  proceso: string
  documento: string
  ruta_final: string
  archivo_final: string
  uniqueId?: string // Added for unique React keys
}

// Helper function to handle 401 unauthorized responses
const handle401Error = () => {
  Swal.fire({
    title: 'Sesión Inválida',
    text: 'Su sesión ha expirado o no es válida. Por favor, inicie sesión nuevamente.',
    icon: 'warning',
    confirmButtonText: 'Ir al Login',
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    // Clear session and redirect to login
    document.cookie = '_FLACTO_AUTH_KEY_=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    window.location.href = '/auth/login'
  })
}

export const fetchDocumentosVisor = async (
  id_periodo: number,
  id_usuario: number,
  token: string
): Promise<DocumentoVisor[]> => {
  try {
    const response = await fetch(`${API_URL}documento-permisos/periodo/${id_periodo}/usuario/${id_usuario}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token || ''}`,
      },
    })

    if (response.status === 401) {
      handle401Error()
      return []
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data || []
  } catch (error) {
    console.error('Error fetching documentos visor:', error)
    throw error
  }
}
